import { schema } from "normalizr";
import Resource from "./resource";
import { partnersTypes } from "../types";
import {client} from "../store";

const partnersSchema = new schema.Entity("partners");

export default new Resource("/partners", partnersTypes, partnersSchema);

client.enableAutoCamelCase("/partners");